'use strict';

module.exports = {};
module.exports.filler = require('./plugin.filler');
module.exports.legend = require('./plugin.legend');
module.exports.title = require('./plugin.title');



//////////////////
// WEBPACK FOOTER
// ./~/chart.js/src/plugins/index.js
// module id = 791
// module chunks = 0 1 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 29 30 32 33 34 35 321